/**
 * Base path del front en el navegador.
 * - Vacío o sin definir: app en la raíz (p. ej. https://restcontrol.woxti.com/login)
 * - "restcontrol" o "/restcontrol": app bajo un subcarpeta en el mismo host
 */
const raw = (process.env.REACT_APP_ROUTER_BASENAME || "").trim();

function normalizeBasename(value: string): string | undefined {
  if (!value || value === "/") return undefined;
  const withSlash = value.startsWith("/") ? value : `/${value}`;
  return withSlash.replace(/\/+$/, "");
}

export const routerBasename = normalizeBasename(raw);

/** URL absoluta del login (p. ej. 401 y logout sin contexto de React) */
export function getLoginPath(): string {
  const b = routerBasename;
  return b ? `${b}/login` : "/login";
}
